import {inject, injectable} from 'inversify';

import {logger} from '../../../utils/logger';
import {FetchUnboundGoalsQuery} from '../../ports/Goal/FetchUnboundGoals/FetchUnboundGoals.query';

@injectable()
export class FetchPreviousGoalsUseCase {
  constructor(
    @inject(FetchUnboundGoalsQuery)
    private readonly query: FetchUnboundGoalsQuery,
  ) {}

  async exec({
    excludeProgramId,
  }: FetchPreviousGoalsUseCase.Props = {}): Promise<FetchPreviousGoalsUseCase.Response> {
    try {
      return this.query.exec({
        excludeProgramId,
        withCourseId: true,
      });
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchPreviousGoalsUseCase {
  export type Props = {
    excludeProgramId?: string;
  };
  export type Response = FetchUnboundGoalsQuery.Response;
}
